// extracted by mini-css-extract-plugin
export var alignEmbedComponent = "index-module--alignEmbedComponent--30e8e";
export var pageComponent = "index-module--pageComponent--48d50";
export var simpleTitle = "index-module--simpleTitle--b0881";